export enum DocumentType {
    TeachingCertificate = 1,
    ProofOfAccomplishment = 2,
    DistrictTraining = 3
}